import SubmissionModal from "./SubmissionModal";
import CancelModal from "./CancelModal";
import CancelQuoteModal from "./CancelQuoteModal";
import DeleteFileModal from "./DeleteFileModal";
import FulfilledModal from "./FulfilledModal";
import FileUnitModal from "./FileUnitModal";
import AddCommentModal from "./AddCommentModal";
import AddFormModal from "./AddFormModal";

export default {
  SubmissionModal,
  CancelModal,
  CancelQuoteModal,
  DeleteFileModal,
  FulfilledModal,
  FileUnitModal,
  AddCommentModal,
  AddFormModal,
};
